export const DELETE_TITLE = 'Excluir Sindicato';
export const DELETE_MESSAGE = 'Você está prestes a excluir o registro de <b>Sindicato</b>. Uma vez feita esta ação não poderá ser desfeita. Você tem certeza de que deseja excluir este registro?';
export const DELETE_CONFIRM_TEXT = 'Sim, desejo excluir o Sindicato';
export const DELETE_SUCCESS_MESSAGE = 'Sindicato excluído com sucesso';
